import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomTable from './Components/CustomTable';
import PageHeading from '../../Components/PageHeading';

//apis===================
import { getAllSites } from '../../api/bannerFpEngine';

//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import { Paper } from '@mui/material';
import { Button } from '@mui/material';

//===============

const TABLE_HEADER = [
	{ id: 'siteId', label: 'Site ID' },
	{ id: 'siteDomain', label: 'Site Domain' },
	{ id: 'ownerEmail', label: 'Owner Email' },
	{ id: 'tag', label: 'Tag' }
];

const BanerFpSiteSearch = () => {
	const [sites, setSites] = useState([]);
	const [sitesLoaded, setSitesLoaded] = useState(false);
	const classes = useStyles();
	const navigate = useNavigate();

	//useEffects
	useEffect(() => {
		(async () => {
			try {
				const { data } = await getAllSites();
				setSites(data?.data?.sites);
			} catch (err) {
				console.log('ERROR IS : ', err);
			}
			setSitesLoaded(true);
		})();
	}, []);

	const handleRowClick = (siteId) => {
		navigate(`/banner-fp/update-config/${siteId}`);
	};

	return (
		<Paper className={classes.dashboardMainContent}>
			<Box className={classes.pageHeadingAndButtonsContainer}>
				<PageHeading
					headingName="BannerFp Sites"
					headingPath={['Dashboard', 'BannerFp Site Search']}
				/>
				<Box className={classes.buttonsContainer}>
					<Button
						size="large"
						className={classes.circularButtonStyles}
						variant="contained"
						fontWeight={600}
						onClick={() => navigate('/banner-fp/create-config')}
					>
						New Setup +
					</Button>
				</Box>
			</Box>

			<Box className={classes.customTableWrapper}>
				<CustomTable
					sites={sites ? sites : []}
					sitesLoaded={sitesLoaded}
					header={TABLE_HEADER}
					rowsPerPageInit={5}
					rowsPerPageOptions={[5, 10, 20]}
					handleRowClick={handleRowClick}
				/>
			</Box>
		</Paper>
	);
};
export default BanerFpSiteSearch;
